import React from 'react'
import { connect } from 'react-redux'
import { Tabs, List, InfiniteScroll } from 'antd-mobile'
import MonthPicker from 'react-month-picker'
import { Container, Wrapper, } from '../../components_renew/Layout'
import IntegralCard from './IntegralCard'
import { IntegralHeader } from '../../components_renew/Integral/IntegralHeader'
import 'react-month-picker/css/month-picker.css'
import { requestIntegralData } from '../../actions/integralAction'
import { withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'

const PAGE_SIZE = 28

let pickerText = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']

let years = (function () {
  let now = new Date()
  let year = now.getFullYear()
  let years = []
  for (let i = 2019; i <= year; i++) {
    years.push(i)
  }
  return years
})()

class IntegralExtend extends React.PureComponent {

  static defaultProps = {
    moment: new window.moment(),
    // handleMonthChange: function () {}
  }
  state = {
    visible: false,
  }

  // 这react-month-pick可能有点坑 https://github.com/nickeljew/react-month-picker
  render () {
    // let { value } = this.state
    const { moment } = this.props
    const { visible } = this.state
    let value = { year: Number(moment.format('YYYY')), month: Number(moment.format('M')) }
    // console.log('value', value)
    return <MonthPicker
      show={visible}
      // ref="pickMonth"
      years={years}
      value={value}
      lang={pickerText}
      onChange={this.onChange}
      onDismiss={this.onDismiss}
    >
      <div className="integral-details__extend" onClick={this.handleMonthClick}>
        <i className={'icon-font icon-arrow-down-filling'}/>
        &nbsp;
        {`${value.year}.${value.month}`}
      </div>
    </MonthPicker>
  }

  handleMonthClick = () => {
    // 这个MonthPicker太老，多少api有点问题
    // this.refs['pickMonth'].show()
    this.setState({ visible: true })
  }
  onDismiss = () => {
    this.setState({ visible: false })
  }

  onChange = (year, month) => {
    this.props.handleMonthChange(year, month)
    this.setState({ visible: false })
  }

}

@withTranslation()
@connect(state => {
  return {
    store: state.integralList
  }
})
@withRouter
// @componentUpdateWithToast
class IntegralDetails extends React.PureComponent {
  constructor (props) {
    super(props)
    const { search: SearchParams } = props.location
    const urlParams = new URLSearchParams(SearchParams)
    this.hideHeader = Boolean(urlParams.get('hideHeader'))
  }
  // componentDidMount () {
  //   this.props.dispatch(fetchIntegralData())
  // }
  state = (() => {
    let k = 'i-1'
    try {
      const {search} = this.props.history.location
      console.log(search)
      const p = new URLSearchParams(search)
      k = p.get('tab')? p.get('tab') : 'i-1'
      console.log(k)
    } catch (e) {

    }
    this.defaultTabKey = k
    return {
      loading0: false,
      loading1: false,
      isLastPage0: false,
      isLastPage1: false,
      pageIndex0: 0,
      pageIndex1: 0,
      listData0: [],
      listData1: [],
      tabKey: this.defaultTabKey,
      moment: window.moment()
    }
  })()

  componentDidMount () {
    // window.toast.show()
    this.props.dispatch(requestIntegralData())
    // this.getIntegralLog(this.state.pageIndex0)
    // this.getGainLog(this.state.pageIndex1)
  }

  render () {
    const { t } = this.props
    const {
      pageIndex0, pageIndex1,
      listData0, listData1,
      isLastPage0, isLastPage1,
      moment,
      tabKey
    } = this.state
    return <Container>
      {!this.hideHeader && <IntegralHeader>
        {t('integral.card_sub')}
      </IntegralHeader>}
      <Wrapper className={''} flex style={{ backgroundColor: 'var(--adm-color-background)' }}>
        <div className={'px-4'}>
          <IntegralCard isDetails={true}/>
        </div>
        <div className={'text-right p-4'}>
          <IntegralExtend moment={moment} handleMonthChange={this.handleMonthChange}/>
        </div>
        <div className={'integral-details__tabs'}>
          <Tabs activeKey={tabKey} onChange={tabKey => this.setState({ tabKey })}>
            <Tabs.Tab key={'i-1'} title={t('integral.tab_1')}/>
            <Tabs.Tab key={'i-0'} title={t('integral.tab_2')}/>
          </Tabs>
          {
            tabKey === 'i-1'
              ? <List className={'overflow-y-auto'}>
                {
                  listData1.map((item, index) => {
                    return <List.Item key={index}
                                      description={item['createTime']}
                                      extra={<span
                                        style={{ color: 'var(--adm-color-primary)' }}>{item['situation']}</span>}
                    >{item['remarks']}
                    </List.Item>
                  })
                }
                <div>
                  <InfiniteScroll hasMore={!isLastPage1} loadMore={this.getGainLog.bind(this, pageIndex1)}/>
                </div>
              </List>
              : <List className={'overflow-y-auto'}>
                {
                  listData0.map((item, index) => {
                    return <List.Item key={index}
                                      description={item['createTime']}
                                      extra={<span
                                        style={{ color: 'var(--adm-color-primary)' }}>{item['situation']}</span>}
                    >{item['remarks']}
                    </List.Item>
                  })
                }
                <div>
                  <InfiniteScroll hasMore={!isLastPage0} loadMore={this.getIntegralLog.bind(this, pageIndex0)}/></div>
              </List>
          }
        </div>
      </Wrapper>
    </Container>
  }

  getIntegralLog = async (pageIndex) => {
    await this.loadMore(pageIndex + 1, 0)
  }

  getGainLog = async (pageIndex) => {
    await this.loadMore(pageIndex + 1, 1)
  }

  loadMore = (pageIndex, type) => {
    const config = {
      url: window.API.Integral.getIntegralLog(type, this.state.moment.format('YYYY-MM')),
      params: {
        pageIndex,
        pageSize: PAGE_SIZE
      }
    }
    // if (pageIndex === 1 && !this.state.loading0 && !this.state.loading1) {
    // window.toast.hide()
    //   window.toast.show()
    // }
    // this.setState({ [`loading${type}`]: true })
    return window.axios.request(config)
      .then(res => {
        const { list, pageTotal } = res
        let isLastPage = false
        if (pageIndex >= pageTotal) {
          isLastPage = true
        }
        let listData = this[`listData${type}`]
        listData = pageIndex === 1 ? list : [...listData, ...list]
        this[`listData${type}`] = listData
        this.setState({
          [`loading${type}`]: false,
          [`isLastPage${type}`]: isLastPage,
          [`pageIndex${type}`]: pageIndex,
          [`listData${type}`]: listData,
        })
        window.toast.hide()
      })
      .catch(error => {
        // this.setState({ [`loading${type}`]: false })
        console.error(error)
        window.toast.fail(error.message)
        window.toast.hide()
      })
  }

  handleMonthChange = (year, month) => {
    this.setState({
      moment: new window.moment(`${year}-${month}`, 'YYYY-MM')
    }, () => {
      // console.log(this.state.moment.format('YYYY-MM'))
      window.toast.show()
      this.getIntegralLog(0)
      this.getGainLog(0)
    })
  }

}

export default IntegralDetails
